import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import { CompanyInfoSection } from './styled';
import NewBadge from './NewBadge';
import CompanyEquimentEntry from './CompanyEquimentEntry';

const CompanyEquipment: React.FunctionComponent = () => {
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );
  const { equipmentList } = useStyles();

  if (!context) return null;

  const { partnerInfo } = context;

  const equips = [...(partnerInfo?.equipments ?? [])].reverse();
  const noEquips = equips.length === 0;

  if (noEquips) return null;

  return (
    <CompanyInfoSection id="equipments">
      <div className="section-title new-column">
        <div className="new-column">
          <CustomizedTypography>보유 장비</CustomizedTypography>
          <NewBadge />
        </div>
      </div>
      <div className={equipmentList}>
        {noEquips && (
          <CustomizedTypography className="no-data">
            업데이트 예정
          </CustomizedTypography>
        )}
        {equips.map((equipment) => (
          <CompanyEquimentEntry equipment={equipment} key={equipment.id} />
        ))}
      </div>
    </CompanyInfoSection>
  );
};

export default CompanyEquipment;

const useStyles = makeStyles((theme) => ({
  equipmentList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(1, 1fr)'
    }
  }
}));
